module.exports = function (fox) {
	'use strict';

	require('./stylus/_style.styl');

	var require__template = require.context('fox-dynamic-injection!fox-template-loader!./templates', true, /\.tpl$/);

	require__template.keys().forEach(function (module) {
		require__template(module)(fox);
	});

	var require__js = require.context('./widget', true, /\.js$/);

	require__js.keys().forEach(function (module) {
		require__js(module)(fox);
	});
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/area/model/promo2/components/login-wizard/index.js
// module id = 125
// module chunks = 5